
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/okta",
      function () {
        return require("private-next-pages/guides/okta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/okta"])
      });
    }
  